<template>
  <div>
    <TopBarTitleComponent
      :title="isEdit ? 'Editar Transportista' : 'Nuevo Transportista'"
      :showBackIcon="false"
    >
      <template slot="right-area">
        <div
          class="d-flex justify-content-end align-items-center"
          style="gap: 12px"
        >
          <ButtonPrimaryComponent
            :title="isEdit ? 'Guardar' : 'Crear'"
            @onSaveClick="handleSave"
          />
          <button
            type="button"
            class="btn btn-outline-secondary"
            @click="$emit('close')"
          >
            Cancelar
          </button>
        </div>
      </template>
    </TopBarTitleComponent>

    <b-container fluid class="pb-4 px-lg-4 pt-4">
      <b-row>
        <b-col xs="12" sm="12" md="8" lg="8" class="mx-auto">
          <div class="card box-shadow">
            <div class="card-body">
              <el-form
                :model="form"
                :rules="rules"
                ref="form"
                label-position="top"
              >
                <el-form-item label="Razón Social" prop="name">
                  <el-input
                    v-model="form.name"
                    placeholder="Nombre del transportista"
                  />
                </el-form-item>

                <el-form-item label="Tipo Identificación" prop="document_type">
                  <el-select v-model="form.document_type" style="width: 100%">
                    <el-option label="PLACA" value="PLACA" />
                    <el-option label="RUC" value="RUC" />
                    <el-option label="CEDULA" value="CEDULA" />
                    <el-option label="PASAPORTE" value="PASAPORTE" />
                  </el-select>
                </el-form-item>

                <el-form-item label="Identificación" prop="document">
                  <el-input
                    v-model="form.document"
                    placeholder="Número de identificación"
                  />
                </el-form-item>

                <el-form-item label="Placa" prop="plate">
                  <el-input v-model="form.plate" placeholder="ABC-1234" />
                </el-form-item>

                <el-form-item label="Correo Electrónico" prop="email">
                  <el-input
                    v-model="form.email"
                    placeholder="email@ejemplo.com"
                  />
                </el-form-item>

                <el-form-item label="Teléfono" prop="phone">
                  <el-input v-model="form.phone" placeholder="Teléfono" />
                </el-form-item>
              </el-form>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import ButtonPrimaryComponent from "../../components/ButtonPrimary";
import TopBarTitleComponent from "../../components/TopBarTitle";
import businessService from "../services/businessService";
import Validate from "@/assets/validate";
import { validateEcuadorRUC, validateEcuadorCedula } from "@/services/Utils";

export default {
  name: "EditCarrierComponent",
  components: { ButtonPrimaryComponent, TopBarTitleComponent },
  props: {
    carrier: { type: Object, default: () => ({}) }
  },
  data() {
    const checkCarrierDocument = (rule, value, callback) => {
      if (!value) return callback(new Error("La identificación es requerida"));
      const docType = this.form.document_type;
      const countryCode = this.currentCountryCode;
      if (countryCode !== "EC") return callback();
      if (docType === "RUC") {
        if (!validateEcuadorRUC(value))
          return callback(
            new Error(
              "El formato del RUC no es válido. Debe tener 13 dígitos y provincia correcta."
            )
          );
      }
      if (docType === "CEDULA") {
        if (!validateEcuadorCedula(value))
          return callback(
            new Error(
              "La cédula ingresada no es válida. Verifica que tenga 10 dígitos y sea correcta."
            )
          );
      }
      callback();
    };
    return {
      form: {
        id: this.carrier.id || null,
        name: this.carrier.name || "",
        document_type: this.carrier.document_type || "PLACA",
        document: this.carrier.document || "",
        plate: this.carrier.plate || "",
        phone: this.carrier.phone || "",
        email: this.carrier.email || ""
      },
      rules: {
        name: [Validate.rules.required()],
        document_type: [Validate.rules.required("change")],
        document: [{ validator: checkCarrierDocument, trigger: "blur" }],
        plate: [Validate.rules.required()],
        email: [Validate.rules.required()]
      }
    };
  },
  computed: {
    isEdit() {
      return !!this.form.id;
    },
    currentCountryCode() {
      const user = this.$store.getters.getUser;
      return user && user.user_business
        ? user.user_business.country_code || "EC"
        : "EC";
    }
  },
  methods: {
    handleSave() {
      this.$refs.form.validate(async valid => {
        if (!valid) return;
        try {
          let response;
          if (this.isEdit) {
            response = await businessService.updateCarrierId(this.form);
          } else {
            response = await businessService.addCarrier(this.form);
          }
          if (response.data.success) {
            this.$emit("saved", { carrier: response.data.carrier });
            this.$emit("close");
          }
        } catch (e) {
          // handled by global interceptor
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-form-item__label {
  font-weight: 700;
  color: #2d2b55;
}
</style>
